import { Box, Button, SpaceBetween } from "@cloudscape-design/components";
import { CancelableEventHandler, ClickDetail } from "@cloudscape-design/components/internal/events";

const Empty: React.FC<React.PropsWithChildren<{
  text: string
}>> = ({ text }) => {
  return (
    <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
      <SpaceBetween size="xxs">
        <div>
          <b>{text}</b>
        </div>
      </SpaceBetween>
    </Box>
  );
};

export default Empty;

export const TableNoMatchState = (props: { onClearFilter: CancelableEventHandler<ClickDetail> | undefined; }) => (
  <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
    <SpaceBetween size="xxs">
      <div>
        <b>No matches</b>
        <Box variant="p" color="inherit">
          We can't find a match.
        </Box>
      </div>
      <Button onClick={props.onClearFilter}>Clear filter</Button>
    </SpaceBetween>
  </Box>
);

export const TableEmptyState =  ({resourceName}: {resourceName: string})  => (
  <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
    <SpaceBetween size="xxs">
      <div>
        <b>No {resourceName.toLowerCase()}s</b>
        <Box variant="p" color="inherit">
          No {resourceName.toLowerCase()}s associated with this resource.
        </Box>
      </div>
      <Button>Create {resourceName.toLowerCase()}</Button>
    </SpaceBetween>
  </Box>
);
